import React, { CSSProperties } from 'react'
import { Rnd as ReactDraggable, DraggableData, ResizableDelta, Position } from 'react-rnd'

interface DraggablePanelState {
  x: number
  y: number
  width: number
  height: number
}

interface DraggablePanelProps {
  dimension?: { x: number; y: number; width: number; height: number }
  minHeight?: number | string
  resizable?: boolean
  centered?: boolean
  style?: CSSProperties
  children?: React.ReactNode
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
}

export class DraggablePanel extends React.Component<DraggablePanelProps, DraggablePanelState> {
  state = { x: 0, y: 0, width: 0, height: 0 }

  draggableWindow: HTMLDivElement | null = null

  componentDidMount() {
    const { dimension, centered, resizable } = this.props

    if (resizable) {
      dimension === undefined
        ? this.setState({ width: 320, height: 350 })
        : this.setState({ width: dimension.width, height: dimension.height })
    }

    if (centered) {
      if (this.draggableWindow) {
        this.setState({ x: -this.draggableWindow.clientWidth / 2, y: -this.draggableWindow.clientHeight / 2 })
      } else {
        throw new Error('DraggablePanel has not been set')
      }
    } else {
      dimension === undefined ? this.setState({ x: 100, y: 100 }) : this.setState({ x: dimension.x, y: dimension.y })
    }
  }

  render() {
    const { style, resizable, minHeight } = this.props
    const { x, y, width, height } = this.state

    return (
      <ReactDraggable
        style={style}
        dragHandleClassName="draggableHandle"
        position={{ x, y }}
        onDragStop={this.handleDragStop}
        enableResizing={this.getResizable()}
        size={resizable ? { width, height } : undefined}
        minHeight={minHeight}
        onResize={this.handleResize}>
        <div ref={node => (this.draggableWindow = node)} tabIndex={0} onKeyDown={this.props.onKeyDown}>
          {this.props.children}
        </div>
      </ReactDraggable>
    )
  }

  getResizable = () => {
    const { resizable } = this.props

    return {
      top: !!resizable,
      right: false,
      bottom: !!resizable,
      left: false,
      topRight: false,
      bottomRight: false,
      bottomLeft: false,
      topLeft: false
    }
  }

  handleDragStop = (_e: unknown, d: DraggableData) => {
    this.setState({ x: d.x, y: d.y })
  }

  handleResize = (_e: unknown, _direction: unknown, ref: HTMLDivElement, _delta: ResizableDelta, position: Position) => {
    if (this.props.resizable) {
      this.setState({
        width: ref.offsetWidth,
        height: ref.offsetHeight,
        ...position
      })
    }
  }
}

export const DraggableHandle: React.FunctionComponent<{ children?: React.ReactNode }> = props => (
  <div className="draggableHandle">{props.children}</div>
)
